import { EIPRNtoNType, ISelectItem } from "../types"

export const IPRDistributionList: ISelectItem[] = [
  {
    label: "3-3",
    value: EIPRNtoNType.IPRNtoNType_3,
  },
  {
    label: "4-4",
    value: EIPRNtoNType.IPRNtoNType_4,
  },
  {
    label: "5-5",
    value: EIPRNtoNType.IPRNtoNType_5,
  },
]
